import ReactPlayer from "react-player";
import React, { Component, Fragment } from "react";
import {
  CardImg,
  Col,
  Row,
  Button,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
} from "reactstrap";

import config from "./../config/local";

class ProductDetail extends Component {
  closeModal = () => {
    this.props.closeModal();
  };

  render() {
    return (
      <Fragment>
        <Modal
          isOpen={this.props.productDetailModal}
          toggle={(event) => this.closeModal()}
          className="modal-lg"
        >
          <ModalHeader toggle={(event) => this.closeModal()}>
            Product Details
          </ModalHeader>
          <ModalBody>
            <Row>
              <Col lg={12} md={12} sm={12} xs={12}>
                <Row>
                  <Label sm={4}>Title :</Label>
                  <Label sm={8}>{this.props.productDetail.title || ""}</Label>
                </Row>
                <Row>
                  <Label sm={4}>Subtitle :</Label>
                  <Label sm={8}>
                    {this.props.productDetail.subtitle || ""}
                  </Label>
                </Row>
                <Row>
                  <Label sm={4}>Description :</Label>
                  <Label sm={8}>
                    {this.props.productDetail.description || ""}
                  </Label>
                </Row>
                <Row>
                  <Label sm={4}>Category :</Label>
                  <Label sm={8}>
                    {this.props.productDetail.category || ""}
                  </Label>
                </Row>
                <Row>
                  <Label sm={4}>SubCategory :</Label>
                  <Label sm={8}>
                    {this.props.productDetail.subCategory || ""}
                  </Label>
                </Row>
                <Row>
                  <Label sm={4}>OriginalPrice :</Label>
                  <Label sm={8}>
                    {this.props.productDetail.original_price || ""}
                  </Label>
                </Row>
                <Row>
                  <Label sm={4}>BasePrice :</Label>
                  <Label sm={8}>
                    {this.props.productDetail.base_price || ""}
                  </Label>
                </Row>
                <Row>
                  <Label sm={4}>Discount Price :</Label>
                  <Label sm={8}>
                    {this.props.productDetail.discount_price || ""}(In
                    Percentage)
                  </Label>
                </Row>
                <Row>
                  <Label sm={4}>Quantity :</Label>
                  <Label sm={8}>
                    {this.props.productDetail.quantity || ""}
                  </Label>
                </Row>
                <Row>
                  <Label sm={4}>Size :</Label>
                  <Label sm={8}>
                    {this.props.productDetail.quantity || ""}(Width x length x
                    height)
                  </Label>
                </Row>
                <Row>
                  <Label sm={4}>Weight :</Label>
                  <Label sm={8}>
                    {this.props.productDetail.quantity || ""}(In Kilogram)
                  </Label>
                </Row>
                <Row>
                  <Label sm={4}>Images :</Label>
                </Row>
                <Row>
                  {this.props.productDetail.images.length ? (
                    this.props.productDetail.images.map((image, index) => (
                      <Col
                        key={index}
                        sm={4}
                        style={{ display: "flex", marginBottom: "5px" }}
                      >
                        <CardImg
                          key={index}
                          width="100%"
                          src={`${config.imageBaseUrl}/${image}`}
                          alt=""
                        />
                      </Col>
                    ))
                  ) : (
                    <Label sm={4}>No Images</Label>
                  )}
                </Row>
                <Row>
                  <Label sm={4}>Videos :</Label>
                </Row>
                <Row>
                  {this.props.productDetail.videos.length ? (
                    this.props.productDetail.videos.map((video, index) => (
                      <Col
                        key={index}
                        sm={12}
                        style={{ display: "flex", marginBottom: "5px" }}
                      >
                        <ReactPlayer
                          width="100%"
                          height="100%"
                          controls={true}
                          url={`${config.videoBaseUrl}/${video}`}
                        />
                      </Col>
                    ))
                  ) : (
                    <Label sm={4}>No Videos</Label>
                  )}
                </Row>
              </Col>
            </Row>
          </ModalBody>
          <ModalFooter>
            <Button color="secondary" onClick={(event) => this.closeModal()}>
              Cancel
            </Button>
          </ModalFooter>
        </Modal>
      </Fragment>
    );
  }
}

export default ProductDetail;
